module.exports = __webpack_public_path__ + "static/img/14000701.ac448b9f.png";